import React from "react";
import Modal from "react-modal";
import './ConfirmationModal.css';
import PropTypes from 'prop-types';
// Important for accessibility
// Modal.setAppElement("#root");

const ConfirmationModal = ({ isOpen, onConfirm, onCancel, message }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      shouldCloseOnOverlayClick={true}
      overlayClassName="logout-overlay"
      className="logout-modal"
    >
      <div className="logout-content">
        {/* <h2>Confirm Logout</h2> */}

        <h2>{message}</h2>

        <div className="logout-actions">
          <button className="btn-cancel" onClick={onCancel}>
            Cancel
          </button>

          <button className="btn-logout" onClick={onConfirm}>
            Logout
          </button>
        </div>
      </div>
    </Modal>
  );
};
ConfirmationModal.propTypes = {
  message: PropTypes.string,
  isOpen: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};
export default ConfirmationModal;